import {
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  Menu,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";

export default function FilterMultiSelect({
  label,
  options,
  selectedValues,
  onSelectionChange,
  texts,
  isRTL,
}) {
  const handleSelect = (value) => {
    const nextValues = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];
    onSelectionChange(nextValues);
  };

  const displayText =
    selectedValues.length === 0
      ? texts.reports?.select || "Select"
      : selectedValues
          .map((id) => {
            const option = options.find((item) => item.id === id);
            return option?.name?.ar || option?.name?.en || option?.name || option?.name_en || id;
          })
          .filter(Boolean)
          .join(", ");

  return (
    <FormControl>
      <FormLabel fontSize="xs">{label}</FormLabel>
      <Menu closeOnSelect={false}>
        <ReportMenuButton w="full" textAlign="left">
          <HStack spacing={2} w="full" justify="space-between">
            <Text noOfLines={1} textAlign={isRTL ? "right" : "left"} fontSize="xs" flex={1}>
              {displayText}
            </Text>
            <Icon as={FaChevronDown} />
          </HStack>
        </ReportMenuButton>
        <MenuList {...reportToolbarStyles.menuList} maxHeight="150px" overflowY="auto" zIndex={2000}>
          {options.map((option) => (
            <MenuItem
              key={option.id}
              onClick={(event) => {
                event.stopPropagation();
                handleSelect(option.id);
              }}
              py={1}
              fontSize="xs"
            >
              <Checkbox isChecked={selectedValues.includes(option.id)} mr={2} size="sm" />
              {option.name?.ar || option.name?.en || option.name || option.name_en}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </FormControl>
  );
}
